export const IS_GTM_DEBUGGER_ENABLED = localStorage.getItem('enableGtmDebugger') === '1';
